module.exports = __webpack_public_path__ + "static/img/h2-3.01d2dca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/h2-3.png
// module id = Z2aM
// module chunks = 1